import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { DATE_FORMATS_FNS, EllipsisText, ReactTable } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { Appointment, DealerLocation } from "models";

type CustomerAppointmentsTableProps = {
  appointments?: Appointment[];
  location?: DealerLocation | null;
};

// TODO: find a solution to this any
const columnHelper = createColumnHelper<any>();

export const CustomerAppointmentsTable = ({ appointments, location }: CustomerAppointmentsTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "date",
        size: 150,
        header: t("v8_date", "Date"),
        cell: ({ row: { original } }) => (
          <span>
            <Icon className="arrow up right from square" /> {original.time_car_app ? formatDate(original.time_car_app, DATE_FORMATS_FNS.dateMonthYearDot) : ""}
          </span>
        )
      }),
      columnHelper.accessor(row => row, {
        id: "wo_nr",
        size: 90,
        header: t("v8_wo", "WO"),
        cell: ({ row: { original } }) => <EllipsisText text={String(original.wo_nr)} />
      }),
      columnHelper.accessor(row => row, {
        id: "reg_nr",
        size: 90,
        header: t("v8_reg_nr", "Registration"),
        cell: ({ row: { original } }) => <EllipsisText text={String(original.reg_number)} />
      }),
      columnHelper.accessor(row => row, {
        id: "apkDate",
        size: 200,
        header: t("v8_apk_date", "APK date"),
        cell: ({ row: { original } }) => <span>{original.car_apk_date ? formatDate(original.car_apk_date, DATE_FORMATS_FNS.dateMonthYear) : ""}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "car_hu_date",
        size: 200,
        header: t("v8_car_hu_date", "Car hu date"),
        cell: ({ row: { original } }) =>
          original.car_hu_date && (
            <span>
              <Icon name="external" /> {original.car_hu_date ? formatDate(original.car_hu_date, DATE_FORMATS_FNS.dateMonthYear) : ""}
            </span>
          )
      }),
      columnHelper.accessor(row => row, {
        id: "car_make",
        size: 100,
        header: t("v8_car_make", "Car make"),
        cell: ({ row: { original } }) => <EllipsisText text={String(original.car_make)} />
      }),
      columnHelper.accessor(row => row, {
        id: "car_model",
        size: 100,
        header: t("v8_car_model", "Car model"),
        cell: ({ row: { original } }) => <EllipsisText text={String(original.car_model)} />
      }),
      columnHelper.accessor(row => row, {
        id: "current_km",
        size: 100,
        header: t("v8_km_state", "KM State"),
        cell: ({ row: { original } }) => <EllipsisText text={String(original.current_km)} />
      })
    ],
    [t]
  );

  return (
    <ReactTable
      columns={columns}
      data={appointments?.toSorted((a, b) => (a.time_car_app > b.time_car_app ? -1 : 1))}
      state={{ columnVisibility: { car_hu_date: Boolean(location?.hu_visible), apkDate: Boolean(location?.apk_visible) } }}
      onRowClick={(data: Appointment) => window.open(`/appointments/${data.id}`, "_blank")}
    />
  );
};
